// extracted by mini-css-extract-plugin
export default {"addLineItem":"WorkLogAdditionalDetails_addLineItem__bEE3i","overlayContainer":"WorkLogAdditionalDetails_overlayContainer__vE+An","overlay":"WorkLogAdditionalDetails_overlay__v-YyB"};